import { extendTheme } from 'native-base';

const theme = extendTheme({
    components: {
        Button: {
            // Can simply pass default props to change default behaviour of components.
            baseStyle: {
                rounded: 'md',
            },
            defaultProps: {
                colorScheme: 'rgb(232, 90, 56)',
            },
        },
    },
    colors: {
        primary: {
            100: "#E85A38",
        },
        config: {
            // Changing initialColorMode to 'dark'
            initialColorMode: 'dark',
        },
    }
})

export default theme